import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { RecoverModel } from 'src/app/models/recover-pass.model';
import { RecoverPassModel } from 'src/app/models/recover.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX, faCheckCircle } from '@fortawesome/free-solid-svg-icons'; // O far para regular
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import { SwalService } from 'src/app/services/utls/swal.service';
import { VerifyAccountComponent } from '../verify-account/verify-account.component';
import { DOCUMENT } from '@angular/common';
import { LoginComponent } from '../login/login.component';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => {};
  @Input() callback_no = () => {};
  loginFormRecover: RxFormGroup;
  passwordFieldsFormRecover: RxFormGroup;
  loginCarg = false;
  faClose = faX;
  typePassword: boolean = true; // Or initialize as needed
  modalCarga?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  correoEnviado = false;
  email:any = "tony@gmail.com";
  tiempoRestante = 120;
  puedeReenviar = false;
  timerInterval: any;
  faCheckCircle = faCheckCircle;
  @Input('isVerified') isVerified: boolean = false;
  private recoverSubscription: Subscription;
  private recoverPasswordSubscription: Subscription;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: RxFormBuilder,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    public swalService: SwalService,
    private messageService: InfoMessageService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initForm();
  }
  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const Recover = new RecoverModel();
      const RecoverPass = new RecoverPassModel();
      this.loginFormRecover = this.fb.formGroup(Recover) as RxFormGroup;
      if (this.authService.tempUserRegistrationData && 
        Object.keys(this.authService.tempUserRegistrationData).length > 0) {
          this.loginFormRecover.patchValue({
            email:  this.authService.tempUserRegistrationData.email
            || this.authService.tempUserRegistrationData.phone
          });
      }
      this.passwordFieldsFormRecover = this.fb.formGroup(RecoverPass) as RxFormGroup;
      resolve();
    });
  }
  recover() {
    const {email} = this.loginFormRecover.value;
    this.email = email;

    if (this.email) {
      this.loginCarg = true; // Show loader or spinner
      this.authService.tempUserRegistrationData = {
        ...(this.isNumber(email) ? { phone: email } : { email: email }),
      }
      this.recoverSubscription = this.authService.recover(this.email, this.document.location.origin).subscribe({
        next: async (response) => {
          this.activeModal.close('register');
          this.modalCarga = this.modalService.open(VerifyAccountComponent, this.ngbModalOptions);
          this.modalCarga.componentInstance.title = "Recuperar contraseña";
          this.modalCarga.componentInstance.msg = "Te hemos enviado un código al " + (this.isNumber(email) ? "número diligenciado" : " correo diligenciado") + ", escríbelo aquí para recuperar tu contraseña.";
          this.modalCarga.componentInstance.method = 'recover-password';
          this.modalCarga.result.then(() => {
          }, () => {
            this.activeModal.close('register');
            this.callback_yes();
          });
        },
        error: (error) => {
          console.error('Login failed', error);
          this.loginCarg = false; // Hide loader
          this.authService.tempUserRegistrationData = {};
        },
      });
    } else {
      this.loginFormRecover.markAllAsTouched();
    }
  }

  changePassword(){
    const { password } = this.passwordFieldsFormRecover.value;

    if (password) {
      this.loginCarg = true;
      this.recoverPasswordSubscription = this.authService.recoverPasswordUser(
        password, 
        this.authService.tempUserRegistrationData?.otp,
        localStorage.getItem('recoverToken')
      ).subscribe({
        next: () => {
          this.authService.tempUserRegistrationData = {};
          this.activeModal.close('register');
          this.modalCarga = this.modalService.open(LoginComponent, this.ngbModalOptions);
          this.messageService.showMessage(
            "¡Contraseña restablecida con éxito!",
            "Inicia sesión con la nueva contraseña.",
            "success"
          );
        },
        complete: () => {
          this.loginCarg = false;
          localStorage.removeItem('recoverToken');
        }
      });
    }
  }

  iniciarContador() {
    this.tiempoRestante = 120;
    this.puedeReenviar = false;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.tiempoRestante--;
      if (this.tiempoRestante <= 0) {
        this.puedeReenviar = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  resend() {
    this.recover();
  }

  onYes() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.activeModal.close('login');
    this.callback_yes();
  }

  onNo() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.authService.tempUserRegistrationData = {};
    this.activeModal.close('close');
    this.callback_no();
  }

  onEmailInput(eventData: any){
    const inputElement = eventData.target as HTMLInputElement;
    const value = inputElement.value;

    const isNumber = this.isNumber(value);

    if(isNumber && value.length > 10){
      this.loginFormRecover.get('email')?.setValue(
        inputElement.value.substring(0,10)
      );
    }
  }

  isNumber(value: string){
    return /^-?\d*\.?\d+$/.test(value);
  }

  ngOnDestroy(){
    // this.messageService.hideActiveMessage();
    if(this.recoverSubscription){
      this.recoverSubscription.unsubscribe();
    }
    if(this.recoverPasswordSubscription){
      this.recoverPasswordSubscription.unsubscribe();
    }
  }

}
